import NiceModal, { ModalDef } from "@ebay/nice-modal-react";
import ProfileModal from "./ProfileModal";
import ActionModal from "./ActionModal";
import ReportMemberModal from "./ReportMemberModal";
import ErrorModal from "./ErrorModal";
import ChatModal from "./ChatModal";
import AdvancedSearchModal from "./AdvancedSearchModal";
import BounakirModal from "./BounakirModal";
import QuestionSelectModal from "./QuestionSelectModal";
import BreakTheIceModal from "./BreakTheIceModal";
import PremiumMessageModal from "./PremiumMessageModal";

const GlobalModalProvider: React.FC = ({ children }) => (
  <NiceModal.Provider>
    {children}
    <ModalDef id="profile_modal" component={ProfileModal} />
    <ModalDef id="action_modal" component={ActionModal} />
    <ModalDef id="reportMember_modal" component={ReportMemberModal} />
    <ModalDef id="error_modal" component={ErrorModal} />
    <ModalDef id="chat_modal" component={ChatModal} />
    <ModalDef id="advancedSearch_modal" component={AdvancedSearchModal} />
    <ModalDef id="bounkair_modal" component={BounakirModal} />
    <ModalDef id="question_modal" component={QuestionSelectModal} />
    <ModalDef id="breakTheIce_modal" component={BreakTheIceModal} />
    <ModalDef id="premiumMessage_modal" component={PremiumMessageModal} />
  </NiceModal.Provider>
);

export default GlobalModalProvider;
